import { toast } from './vanillaToast.js'
import checkStamp from 'check-stamp.js'
import { FetchRequest } from '@rails/request.js'

async function sendRequest(url, method = 'get', body = null) {
  const options = { redirect: 'manual' }
  if (body) {
    options.body = body
  }

  const request = new FetchRequest(method, url, options)
  const response = await request.perform()

  let data
  if (response.ok) {
    try {
      data = await response.json
    } catch {
      data = response
    }
  } else {
    try {
      data = await response.json
    } catch {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
  }

  return data
}

export default {
  async isUnassignedAndUncheckedProduct(checkableType, checkableId, isMentor) {
    if (!isMentor) return
    if (checkableType === 'Product') {
      const hasCheckerResult = await this.hasChecker(checkableId)
      const isCheckedResult = await this.isChecked(checkableType, checkableId)
      return hasCheckerResult === false && isCheckedResult === false
    }
  },

  async check(checkableType, checkableId, url, method) {
    const params = {
      checkable_type: checkableType,
      checkable_id: checkableId
    }

    try {
      const data = await sendRequest(url, method, params)

      if (data.message) {
        toast(data.message, 'error')
      } else {
        checkStamp()
        const message =
          checkableType === 'Product'
            ? '提出物を合格にしました。'
            : '日報を確認済みにしました。'
        sessionStorage.setItem('showToast', message)
      }
    } catch (error) {
      console.warn(error)
    }
  },

  async assignChecker(productId, currentUserId) {
    const params = {
      product_id: productId,
      current_user_id: currentUserId
    }

    try {
      const json = await sendRequest('/api/products/checker', 'patch', params)

      if (json.message) {
        alert(json.message)
      } else {
        alert('提出物の担当になりました。')
        sessionStorage.setItem('showToast', '担当になりました。')
      }
    } catch (error) {
      console.warn(error)
    }
  },

  async isChecked(checkableType, checkableId) {
    try {
      const json = await sendRequest(
        `/api/checks.json/?checkable_type=${checkableType}&checkable_id=${checkableId}`
      )
      return !!json[0]
    } catch (error) {
      console.warn(error)
    }
  },

  async hasChecker(productId) {
    try {
      const json = await sendRequest(
        `/api/products/checker.json?product_id=${productId}`
      )
      return !!json.checker_name
    } catch (error) {
      console.warn(error)
    }
  }
}
